<div class="main-card mb-3 card custom-card" #invoiceContainer>
    <div class="invoice-container">
        <div class="invoice-header"
            style="display: flex; justify-content: space-between; align-items: flex-start;">
            <!-- Center Content -->
            <div style="text-align: lefts; flex: 1;">
                <img src="./assets/images/chettinad-link-logo - Copy - Copy.png"
                    style="width: 120px;">
                <p><strong>Cal4care Telecommunication Services [I] Pvt
                        LTD</strong></p>
                <p>Flat No: 42A, Shree Raghavendra Nagar, Kalanivasal, Karaikudi
                    - 630002, Tamilnadu.</p>
                <p>Sales: <strong><a
                            href="tel:918072805198">+918072805198</a></strong></p>
                <p>Support: <strong><a
                            href="tel:918072650199">+918072650199</a></strong></p>
                <p>Email: <a
                        href="mailto:info@chettinadlink.com">info&#64;chettinadlink.com</a></p>
            </div>

            <!-- Right Logo -->
            <img *ngIf="paid_amount" src="./assets/img/paid_seal_stamp.jpg"
                style="width: 120px;">
            <!-- <img src="./assets/img/unpaid.png" style="width: 120px;"> -->
        </div>

        <div class="info-grid row" *ngFor="let v of userdetails">
            <div class="left-info col-12 col-lg-4">
                <p id="user_name"><strong>{{v.first_name}}
                        {{v.last_name}}</strong></p>
                <p id="address">{{addressOnly}}</p>
                <p id="city">{{city}}</p>
                <!-- <p>TamilNadu</p> -->
                <p id="phone">{{v.phone}}</p>
                <p id="email">{{v.email}}</p>
            </div>
            <div class="middle-info col-12 col-lg-4">
                <p id="expired_date"><strong>Expire Date</strong>
                    : {{ formatDate1(expiredDate) }}</p>
                <p id="start_date"><strong>Plan Start Date</strong>
                    : {{ startDate }}</p>
                <p id="end_date"><strong>Plan End Date</strong>
                    : {{ endDate }}</p>
            </div>
            <!-- <div class="right-info col-12 col-lg-4">
                <p id="invoice_no"><strong>INVOICE NO</strong>:
                    {{invoice_no}}</p>
                <p id="invoive_date"><strong>INVOICE DATE</strong>:
                    {{startDate}}</p>
                <p id="time_dilivery"><strong>TIME DELIVERED</strong>:
                    {{time}}</p>
            </div> -->
        </div>
        <div class="table-responsive">
            <table class="invoice-table">
                <thead>
                    <tr>
                        <th>Services</th>
                        <th>Connection</th>
                        <th>Plan Charges</th>
                        <th>Other Charges</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td id="plan_name"><strong>{{ planName }}</strong></td>
                        <td>1</td>
                        <td id="plan_price">₹{{ planPrice | number: '1.2-2'
                            }}</td>
                        <td id="other_price">₹0.00</td>
                        <!-- <td>₹{{ otherCharges | number: '1.2-2' }}</td> -->
                        <td id="plan_price_total">₹{{ planPrice | number:
                            '1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="totals">
            <div class="totals-section">
                <p>
                    <strong><span>Subtotal</span>:</strong>
                    <span class="price">₹{{ planPrice | number: '1.2-2'
                        }}</span>
                </p>
                <p id="gst">
                    <strong><span>Taxes(GST) (18%)</span>:</strong>
                    <span class="price">₹{{ (planPrice * 0.18) | number:
                        '1.2-2' }}</span>
                </p>
                <p class="total">
                    <strong><span>Total Price</span>:</strong>
                    <span class="price" id="total_price">₹{{ (planPrice * 1.18)
                        | number:
                        '1.2-2' }}</span>
                </p>
            </div>
        </div>
        <div class="btn-section">
            <button *ngIf="!paid_amount" type="button" class="btn btn-primary"
                (click)="createInvoice()" [disabled]="isProcessing">{{
                isProcessing ? 'Processing...' : 'Process Pay' }}</button>
            <button *ngIf="paid_amount" type="button" class="btn btn-primary"
                (click)="downloadInvoice(invoice_ID,invoice_NO)">Download
                Invoice</button>
            <button type="button" class="btn btn-danger"
                (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

<!-- QR SCANER -->

<div class="plan-modal" *ngIf="showQRModal">
    <div class="modal-box">
        <!-- Header -->
        <div class="modal-header">
            <h3>Scan or Pay Directly</h3>
            <button class="close-btn"
                (click)="showQRModal = false">&times;</button>
        </div>

        <!-- Content -->
        <div class="modal-content">
            <p>You can scan the QR code below or click the button to pay
                directly.</p>

            <!-- QR Code -->
            <div class="qr-container">
                <qrcode
                    [qrdata]="stringQrCode"
                    [width]="250"
                    [errorCorrectionLevel]="'M'">
                </qrcode>
            </div>

            <!-- OR Divider -->
            <div class="or-divider">OR</div>

            <!-- Direct Pay Button -->
            <button class="pay-now-btn" (click)="payNow()">
                Pay Now
            </button>
        </div>
    </div>
</div>
